import React from 'react';
import RadioButtonController from '@/components/radioButtonController';
import TextInfo, {
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_KIND,
} from '@/bit/components/components.text';
import {
  OPERATION,
  MOBILE_LINE_ACTIONS,
  LAND_LINE_ACTIONS,
  SIM_TYPES,
  MORE_INFO_TEXT,
} from '@/constants/operation';
import { LINE_TYPE } from '@/constants/constant';
import FormTemplate, { THEMES, TITLE_SIZE } from '@/components/formTemplate';
import MoreInfoText from '@/components/moreInfoText';
import InputController from '@/components/inputController';

function Operation({
  nestIndex,
  id,
  control,
  lineActions,
  defaultLineAction,
  lineActionOnChange,
  simTypes,
  operation,
  type,
  watch,
  title,
  nextStep = null,
  forceHideSimTypes = null,
}) {
  return (
    <div className="operation">
      <FormTemplate
        titleText={title}
        theme={THEMES.NORMAL}
        cyData="palanca"
        titleSize={title ? TITLE_SIZE.CAPTION1 : TITLE_SIZE.TITLE6}
      >
        {Array.isArray(lineActions) && (
          <div className="choose-operation-container">
            <RadioButtonController
              inputName={`${id}.${nestIndex}.${OPERATION.ACTION_CHOICER.NAME}`}
              inputId={`${id}.${nestIndex}.${OPERATION.ACTION_CHOICER.ID}`}
              control={control}
              rules={{
                required: OPERATION.ACTION_CHOICER.RULES.REQUIRED,
                validate: (fieldValue) => {
                  const isValid =
                    OPERATION.ACTION_CHOICER.RULES.VALIDATE.MIGRATION_EMPTY_PHONE.checkFunc(
                      fieldValue
                    );
                  return (
                    isValid ||
                    OPERATION.ACTION_CHOICER.RULES.VALIDATE
                      .MIGRATION_EMPTY_PHONE.message
                  );
                },
              }}
              label={OPERATION.ACTION_CHOICER.LABEL}
              options={lineActions}
              defaultValue={
                defaultLineAction || { value: operation?.lineAction }
              }
              handleOnChange={(data) => {
                lineActionOnChange(nestIndex, data);
              }}
            />
          </div>
        )}
        {type === LINE_TYPE.MOBILE_LINE &&
          watch(`${id}.${nestIndex}.${OPERATION.ACTION_CHOICER.ID}`)?.value ===
            MOBILE_LINE_ACTIONS.PORTABILITY && (
            <InputController
              className="choose-operation-container__input"
              inputName={`${id}.${nestIndex}.${OPERATION.PORTABILITY.NAME}`}
              inputId={`${id}.${nestIndex}.${OPERATION.PORTABILITY.ID}`}
              control={control}
              mask={OPERATION.PORTABILITY.MASK}
              rules={{
                required: OPERATION.PORTABILITY.RULES.REQUIRED,
                validate: (fieldValue) =>
                  OPERATION.PORTABILITY.RULES.VALIDATE.PORTABILITY_PHONE_FORMAT.checkFunc(
                    fieldValue
                  ) ||
                  OPERATION.PORTABILITY.RULES.VALIDATE.PORTABILITY_PHONE_FORMAT
                    .message,
              }}
              label={OPERATION.PORTABILITY.LABEL}
              info={OPERATION.PORTABILITY.INFO}
            />
          )}
        {type === LINE_TYPE.LAND_LINE &&
          watch(`${id}.${nestIndex}.${OPERATION.ACTION_CHOICER.ID}`)?.value ===
            LAND_LINE_ACTIONS.PORTABILITY && (
            <InputController
              className="choose-operation-container__input"
              inputName={`${id}.${nestIndex}.${OPERATION.PORTABILITY.NAME}`}
              inputId={`${id}.${nestIndex}.${OPERATION.PORTABILITY.ID}`}
              control={control}
              mask={OPERATION.LAND_LINE_PORTABILITY.MASK}
              rules={{
                required: OPERATION.LAND_LINE_PORTABILITY.RULES.REQUIRED,
                validate: (fieldValue) =>
                  OPERATION.LAND_LINE_PORTABILITY.RULES.VALIDATE.PORTABILITY_PHONE_FORMAT.checkFunc(
                    fieldValue
                  ) ||
                  OPERATION.LAND_LINE_PORTABILITY.RULES.VALIDATE
                    .PORTABILITY_PHONE_FORMAT.message,
              }}
              label={OPERATION.LAND_LINE_PORTABILITY.LABEL}
            />
          )}
        {type === LINE_TYPE.MOBILE_LINE &&
          watch(`${id}.${nestIndex}.${OPERATION.ACTION_CHOICER.ID}`)?.value ===
            MOBILE_LINE_ACTIONS.MIGRATION &&
          nextStep && (
            <div>
              <FormTemplate titleText={nextStep?.title} theme={THEMES.FULL}>
                <TextInfo
                  text={nextStep?.description}
                  color={TEXT_COLOR.GREY5}
                  size={TEXT_SIZE.CAPTION1}
                />
              </FormTemplate>
            </div>
          )}
        {!forceHideSimTypes &&
          Array.isArray(simTypes) &&
          type === LINE_TYPE.MOBILE_LINE &&
          watch(`${id}.${nestIndex}.${OPERATION.ACTION_CHOICER.ID}`)?.value !==
            MOBILE_LINE_ACTIONS.MIGRATION && (
            <>
              <div className="choose-operation-container__text">
                <TextInfo
                  text={OPERATION.CARD_CHOICER.LABEL}
                  kind={TEXT_KIND.PARAGRAPH}
                  color={TEXT_COLOR.GREY6}
                  size={TEXT_SIZE.CAPTION2}
                />
              </div>
              <div className="choose-operation-container">
                <RadioButtonController
                  inputName={`${id}.${nestIndex}.${OPERATION.CARD_CHOICER.NAME}`}
                  inputId={`${id}.${nestIndex}.${OPERATION.CARD_CHOICER.ID}`}
                  control={control}
                  rules={{
                    required: OPERATION.CARD_CHOICER.RULES.REQUIRED,
                  }}
                  label={OPERATION.CARD_CHOICER.LABEL}
                  options={simTypes}
                  defaultValue={{ value: operation?.simType }}
                />
                {watch(`${id}.${nestIndex}.${OPERATION.CARD_CHOICER.ID}`)
                  ?.value === SIM_TYPES.ESIM && (
                  <MoreInfoText
                    text={MORE_INFO_TEXT.TEXT}
                    moreInfo={MORE_INFO_TEXT.MORE_INFO}
                  />
                )}
              </div>
            </>
          )}
      </FormTemplate>

      <style jsx>
        {`
          .operation {
            margin: 0px 0px 4px 0px;
          }
          .choose-operation-container {
            display: flex;
            direction: row;
            margin: 0px 0px 0px 0px;
            align-items: center;
          }
          :global(.choose-operation-container__input) {
            margin: 0px 0 8px 0px;
            width: 100%;
          }
          :global(.choose-operation-container__text) {
            margin: 0px 0 8px 0;
            position: relative;
          }
          :global(.choose-operation-container__text:last-child) {
            margin: 8px 0 0px 0;
            position: relative;
          }
        `}
      </style>
    </div>
  );
}
export default Operation;
